import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Aside = _resolveComponent("Aside")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Main = _resolveComponent("Main")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "layout-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_Aside),
      _createVNode(_component_el_container, {
        class: _normalizeClass(["flex-center", { 'layout-backtop': !$setup.isFixedHeader }])
      }, {
        default: _withCtx(() => [
          ($setup.isFixedHeader)
            ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_scrollbar, {
            ref: "layoutDefaultsScrollbarRef",
            class: _normalizeClass({ 'layout-backtop': $setup.isFixedHeader })
          }, {
            default: _withCtx(() => [
              (!$setup.isFixedHeader)
                ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_Main)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_el_backtop, { target: ".layout-backtop .el-scrollbar__wrap" })
    ]),
    _: 1
  }))
}